import VscError from "./VscError";

function assertDefined(obj: Record<string, any>) {


    for (const k of Object.keys(obj)) {
        if (obj[k] === undefined) {
            throw new VscError(`Required attribute ${k} missing`);
        }
    }
    return;

}
export default assertDefined;